import { render, staticRenderFns } from "./RegistroArma.vue?vue&type=template&id=4156ccaa&scoped=true"
import script from "./RegistroArma.vue?vue&type=script&lang=js"
export * from "./RegistroArma.vue?vue&type=script&lang=js"
import style0 from "./RegistroArma.vue?vue&type=style&index=0&id=4156ccaa&prod&lang=css"
import style1 from "./RegistroArma.vue?vue&type=style&index=1&id=4156ccaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156ccaa",
  null
  
)

export default component.exports